
namespace Core.Customer {

    export abstract class CrossSellOption {
        BookingId: number = 0;
        CrossSellType: Booking.CrossSellType;
        PriceIsPerPerson: boolean = false;
        TeaserPrice: number = 0;

        public constructor(bookingId :number,
                           crossSellType :Booking.CrossSellType,
                           priceIsPerPerson :boolean,
                           teaserPrice :number)
        {
            this.BookingId = bookingId;
            this.CrossSellType = crossSellType;
            this.PriceIsPerPerson = priceIsPerPerson;
            this.TeaserPrice = teaserPrice;
        }
    }

    export class CrossSellProductOption extends CrossSellOption {
        ImageUrl: string;
        ProductDetails: any;
        Title: string;

        public constructor(bookingId :number,
                           crossSellType :Booking.CrossSellType,
                           priceIsPerPerson :boolean,
                           teaserPrice :number,
                           imageUrl :string,
                           productDetails :any,
                           title :string)
        {
            super(bookingId, crossSellType, priceIsPerPerson, teaserPrice);
            this.ImageUrl = imageUrl;
            this.ProductDetails = productDetails;
            this.Title = title;
        }
    }

    export class CrossSellHotelOption extends CrossSellProductOption {
        Hotel: Hotels.StaticHotel;

        public constructor(bookingId :number,
                           crossSellType :Booking.CrossSellType,
                           priceIsPerPerson :boolean,
                           teaserPrice :number,
                           imageUrl :string,
                           productDetails :any,
                           title :string,
                           hotel :Hotels.StaticHotel)
        {
            super(bookingId, crossSellType, priceIsPerPerson, teaserPrice, imageUrl, productDetails, title);
            this.Hotel = hotel;
        }
    }

    export class CrossSellFlightExtraOption extends CrossSellOption {
        Url: string;

        public constructor(bookingId :number,
                           crossSellType :Booking.CrossSellType,
                           priceIsPerPerson :boolean,
                           teaserPrice :number,
                           url :string)
        {
            super(bookingId, crossSellType, priceIsPerPerson, teaserPrice);
            this.Url = url;
        }
    }

    export interface RecentSearchContentCard {
        DepartureAirports?: ManageBooking.AirportSummary[];
        Destinations?: Destinations.DestinationSummary[];
        StartDate: string;
        EndDate: string;
        Title: string;
        TitleResource: string;
        ImageUrl: string;
        Icons: string[];
        Adults: number;
        Children: number;
        Rooms: number|null;
    }

    // this is used for mix-panel analytics
    export enum DashboardTileType {
        SignIn,
        Trip,
        Search,
        Destination,
        LastHotel,
        CrossSellHotels,
        CrossSellAttractions,
        CrossSellTransfers,
        CrossSellCarHire,
        CrossSellSeats,
        CrossSellBaggage,
        InsuranceOption,
        InsuranceClaim,
        InsuranceConf,
        TravelGuide,
        ContactUs,
        ReviewHotel,
        AppPromo,
        InspirationalContent,
    }
}
